import { Component, OnInit } from '@angular/core';
import {OrganizationChartModule} from 'primeng/organizationchart';
import { TreeNode, MessageService } from 'primeng/api';
import { OrganismService } from 'src/app/partners/organisms/organisms.service';

@Component({
  selector: 'app-organism-org-chart',
  templateUrl: './organism-org-chart.component.html',
  styleUrls: ['./organism-org-chart.component.scss'],
  providers: [MessageService]
})
export class OrganismOrgChartComponent implements OnInit {

  data1: TreeNode[];

    data2: TreeNode[];

    selectedNode: TreeNode;

    constructor(private messageService: MessageService,private organismService:OrganismService) {}

    ngOnInit() {
        let ip={};
        this.organismService.searchOrganisms(ip).subscribe(response => {
            let rowData = response['result'];
          },
          error => {
          })
        this.data1 = [{
            label: 'Fueni',
            type: 'person',
            styleClass: 'ui-person',
            expanded: true,
            data: {name:'Organisms', 'avatar': 'walter.jpg'},
            children: [
                {
                    label: 'Organism',
                    type: 'person',
                    styleClass: 'ui-person',
                    expanded: true,
                    data: {name:'Organism1', 'avatar': 'saul.jpg'},
                    children:[{
                        label: 'Hospital1',
                        styleClass: 'department-cfo'
                    },
                    {
                        label: 'Practionar',
                        styleClass: 'department-cfo'
                    }],
                },
                {
                    label: 'Organism2',
                    type: 'person',
                    styleClass: 'ui-person',
                    expanded: true,
                    data: {name:'Organism 2', 'avatar': 'mike.jpg'},
                    children:[{
                        label: 'Hospital2',
                        styleClass: 'department-coo'
                    }]
                }, 
                {
                    label: 'Organism3',
                    type: 'person',
                    styleClass: 'ui-person',
                    expanded: true,
                    data: {name:'Organism3', 'avatar': 'jesse.jpg'},
                    children:[{
                        label: 'Hospital',
                        styleClass: 'department-cto',
                        expanded: true,
                        children:[{
                            label: 'Abc',
                            styleClass: 'department-cto'
                        },
                        {
                            label: 'Def',
                            styleClass: 'department-cto'
                        },
                        {
                            label: 'Ghi',
                            styleClass: 'department-cto'
                        }]
                    },
                    {
                        label: 'Practionar',
                        styleClass: 'department-cto'
                    },
                    {
                        label: 'Logistics',
                        styleClass: 'department-cto'
                    }]
                }
            ]
        }];

        this.data2 = [{
            label: 'F.C Barcelona',
            expanded: true,
            children: [
                {
                    label: 'F.C Barcelona',
                    expanded: true,
                    children: [
                        {
                            label: 'Chelsea FC'
                        },
                        {
                            label: 'F.C. Barcelona'
                        }
                    ]
                },
                {
                    label: 'Real Madrid',
                    expanded: true,
                    children: [
                        {
                            label: 'Bayern Munich'
                        },
                        {
                            label: 'Real Madrid'
                        }
                    ]
                }
            ]
        }];
    }

    onNodeSelect(event) {
        this.messageService.add({severity: 'success', summary: 'Node Selected', detail: event.node.label});
    }
}



